import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { organizationJsonLd } from "../lib/jsonLd";
import { useReadingAnalytics } from "../lib/analytics";

export const Layout = () => {
  const { pathname, hash } = useLocation();
  useReadingAnalytics(pathname);

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{organizationJsonLd()}</script>
      </Helmet>
      <SiteHeader />
      <main>
        <Outlet />
      </main>
      <SiteFooter />
    </>
  );
};
